import { ref, computed } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-22657e7c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "xsolla-native-price-wrap"
};
const _hoisted_2 = {
  class: "xsolla-native-price-table"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "xsolla-native-price-head"
}, [/*#__PURE__*/_createElementVNode("span", null, "国家/地区"), /*#__PURE__*/_createElementVNode("span", null, "价格")], -1));
const _hoisted_4 = {
  class: "xsolla-native-price-row"
};
const _hoisted_5 = {
  class: "xsolla-native-price-value"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "xsolla-native-currency"
}, "RUB", -1));
const _hoisted_7 = {
  key: 0,
  class: "xsolla-native-price-actions"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "xsolla-native-price-tip"
}, "*本地价格采取 Xsolla 定价模式，俄罗斯用户将优先看到该价格", -1));
const _hoisted_9 = {
  class: "xsolla-vat-row"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "xsolla-vat-title"
}, "俄罗斯 VAT 调价"), /*#__PURE__*/_createElementVNode("div", {
  class: "xsolla-vat-tip"
}, "开启后俄罗斯本地价格将自动上调 22%，用于覆盖 VAT 成本")], -1));
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'XsollaNativePriceFields',
  props: {
    modelValue: null,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["native-price-change", "vat-change"],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    // 谷歌 Xsolla 特有字段：俄罗斯本地价格（可手改可还原）+ VAT 调价开关
    // 默认价格 / 折扣 / 折扣描述与 iOS 共用 ThirdPartyPricePanel，这里只补渠道特有的两项
    const formRef = ref(null);
    const nativePriceEditing = ref(false);
    // 编辑草稿：编辑的是展示中的最终价，确认才生效，取消直接丢弃
    const nativePriceDraft = ref('');
    const russiaPrice = computed(() => {
      var _props$modelValue$pro;
      return (_props$modelValue$pro = props.modelValue.prodNativePrices) === null || _props$modelValue$pro === void 0 ? void 0 : _props$modelValue$pro[0];
    });
    const russiaDisplayPrice = computed(() => {
      var _russiaPrice$value, _russiaPrice$value2;
      return ((_russiaPrice$value = russiaPrice.value) === null || _russiaPrice$value === void 0 ? void 0 : _russiaPrice$value.prodPrice) || ((_russiaPrice$value2 = russiaPrice.value) === null || _russiaPrice$value2 === void 0 ? void 0 : _russiaPrice$value2.originProdPrice);
    });
    const formModel = computed(() => {
      var _russiaPrice$value3;
      return {
        ruPrice: (_russiaPrice$value3 = russiaPrice.value) === null || _russiaPrice$value3 === void 0 ? void 0 : _russiaPrice$value3.originProdPrice
      };
    });
    // 本地价只校验大于 0：7 折下限与不高于官方价只约束 USD 默认价
    const positivePriceRules = [{
      required: true,
      message: '请输入价格',
      trigger: ['change', 'blur']
    }, {
      validator: (_rule, value) => Number(value) > 0 ? Promise.resolve() : Promise.reject('价格必须大于 0'),
      trigger: ['change', 'blur']
    }];
    const startNativePriceEdit = () => {
      nativePriceDraft.value = russiaDisplayPrice.value || '';
      nativePriceEditing.value = true;
    };
    const confirmNativePriceEdit = () => {
      emit('native-price-change', nativePriceDraft.value);
      nativePriceEditing.value = false;
    };
    const cancelNativePriceEdit = () => {
      nativePriceEditing.value = false;
    };
    const validate = async () => {
      try {
        var _formRef$value;
        await ((_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.validate());
        return true;
      } catch {
        return false;
      }
    };
    const clearValidate = () => {
      var _formRef$value2;
      return (_formRef$value2 = formRef.value) === null || _formRef$value2 === void 0 ? void 0 : _formRef$value2.clearValidate();
    };
    expose({
      validate,
      clearValidate
    });
    return (_ctx, _cache) => {
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_switch = _resolveComponent("a-switch");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createBlock(_component_a_form, {
        ref_key: "formRef",
        ref: formRef,
        model: _unref(formModel),
        "label-col": {
          style: 'width: 98px'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          label: "本地价格",
          name: "ruPrice",
          required: "",
          rules: positivePriceRules
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
            class: _normalizeClass({
              'xsolla-vat-mark': __props.modelValue.vatEnabled
            })
          }, "俄罗斯", 2), _createElementVNode("span", _hoisted_5, [_hoisted_6, _withDirectives(_createElementVNode("span", {
            class: "xsolla-native-price-number"
          }, _toDisplayString(_unref(russiaDisplayPrice)), 513), [[_vShow, !nativePriceEditing.value]]), _withDirectives(_createVNode(_component_a_input_number, {
            value: nativePriceDraft.value,
            step: 0.01,
            controls: false,
            precision: 2,
            "string-mode": "",
            disabled: __props.disabled,
            "onUpdate:value": _cache[0] || (_cache[0] = price => nativePriceDraft.value = price || '')
          }, null, 8, ["value", "step", "disabled"]), [[_vShow, nativePriceEditing.value && !__props.disabled]]), !__props.disabled ? (_openBlock(), _createElementBlock("span", _hoisted_7, [_withDirectives(_createVNode(SvgIcon, {
            class: "xsolla-native-price-icon xsolla-native-price-edit",
            "icon-class": "edit",
            onClick: startNativePriceEdit
          }, null, 512), [[_vShow, !nativePriceEditing.value]]), _withDirectives(_createVNode(SvgIcon, {
            class: "xsolla-native-price-icon",
            "icon-class": "confirm",
            onClick: confirmNativePriceEdit
          }, null, 512), [[_vShow, nativePriceEditing.value]]), _withDirectives(_createVNode(SvgIcon, {
            class: "xsolla-native-price-icon xsolla-native-price-close",
            "icon-class": "close",
            onClick: cancelNativePriceEdit
          }, null, 512), [[_vShow, nativePriceEditing.value]])])) : _createCommentVNode("", true)])])]), _hoisted_8])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "VAT调价"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_a_switch, {
            checked: __props.modelValue.vatEnabled,
            disabled: __props.disabled,
            onChange: _cache[1] || (_cache[1] = checked => _ctx.$emit('vat-change', checked))
          }, null, 8, ["checked", "disabled"]), _hoisted_10])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]);
    };
  }
});